import { TextRow } from "components/ui/skeleton/Skeleton.styled";

interface StringProps {
    className?: string;
}

export function StringSkeleton({ className }: StringProps): JSX.Element {
    return <TextRow className={className} />;
}
